<script>
    import { getFullImages } from '@/api/file.js';

    export default {
        computed: {
            isShowPreview() { return this.$store.getters.IS_SHOW_BIG_PREVIEW },
            selectFile() { return this.$store.getters.SELECT_FILE },
        },
        methods: {
            async closePreview() {
                this.$store.commit('IS_SHOW_BIG_PREVIEW', false);
            },
            async getImage() {
                const response = await getFullImages(this.selectFile.fileUuid);
                if (response != null) {
                    this.selectFile.setImagePath(response);
                }
            }
        },
        watch: {
            'selectFile' (newValue) {
                if (newValue == null) return;
                if (newValue.imagePath == null) {
                    this.getImage();
                }
            }
        }
    }
</script>


<template>
    <div 
        v-if="isShowPreview"
        @click="closePreview"
    >
        <span>
            <img 
                :src="selectFile['imagePath']"
                :onError="getImage"
            >
        </span>
    </div>
</template>


<style scoped>
    div {
        position: fixed;
        background-color: #000000aa;
        z-index: 100;
        width: 100dvw;
        height: 100dvh;

        display: flex;
        align-items: center;
        justify-content: center 
    }
    span {
        box-shadow: inset 0px 0px 0px 2px #ffffff50;
    }
    img {
        display: block;
        max-width: 90dvw;
        max-height: 90dvh;
    }
</style>